export default __webpack_public_path__ + "static/media/settings.f9ecb1fa.svg";